import { render, staticRenderFns } from "./ReportMobileTakenMeals.vue?vue&type=template&id=b622b0be"
import script from "./ReportMobileTakenMeals.vue?vue&type=script&lang=js"
export * from "./ReportMobileTakenMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports